<button mat-flat-button
  [id]="buttonId"
  (click)="buttonExecutFn()"
  (mousedown)="clickMouseDown()"
  [class]="classInput"
  [disabled]="!!isDisabled">
  <ng-content></ng-content>
  <span class="text-button ignore-row {{ labelClass }}">{{buttonName}}</span>
</button>
